import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpune() {



  const cardData =
  {
    keyword: 'Corporate cab service in pune',
    heading: 'Pune Corporate Cars India Private Limited: Corporate cab service in pune',
    headingDescription: 'Pune Corporate Cars India Private Limited offers a premium Corporate Cab Service in Pune, delivering reliable, comfortable, and professional travel solutions for businesses, executives, and corporate teams. Our fleet of luxury sedans, SUVs, and premium cars ensures smooth and punctual transfers for meetings, airport commutes, and corporate events. With well-trained chauffeurs, fully air-conditioned vehicles, and flexible rental options, we provide a seamless travel experience that combines efficiency with elegance. Whether it’s daily employee transport, VIP transfers, or client visits, Pune Corporate Cars India Private Limited guarantees safety, comfort, and professionalism in every ride. Choose Pune Corporate Cars India Private Limited’ Corporate Cab Service in Pune for a smart, stress-free, and sophisticated travel experience that perfectly fits your business needs.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



    "services": [
    {
      "name": "Corporate Taxi Service Pune",
      "description": "Corporate Taxi Service Pune offers a premium, reliable, and time-efficient transportation solution designed specifically for business professionals and enterprise teams. Our fleet includes sedans, SUVs, and luxury vehicles to ensure smooth and comfortable daily travel. We prioritize punctuality, ensuring employees reach meetings, conferences, and office locations on time. Every ride is monitored for safety and route optimization to give companies complete peace of mind. With experienced chauffeurs, high-quality vehicles, and flexible billing cycles, we support organizations in streamlining their mobility needs. Whether it’s daily commute or special corporate events, our service ensures comfort, professional etiquette, and top-class travel experience for your team."
    },
    {
      "name": "Employee Transportation Service Pune",
      "description": "Employee Transportation Service Pune is designed for companies that require systematic, safe, and punctual mobility solutions for their workforce. From shift-based operations to regular office hours, our transport plans align seamlessly with company schedules. Vehicles are equipped with GPS tracking, comfortable interiors, and regular sanitization for complete safety. We offer customizable routes, dedicated coordinators, and automated reporting to make employee movement easy and stress-free. Our trained chauffeurs ensure safe travel along optimized routes, maintaining high service standards at all times. Trusted by IT parks, enterprises, and industrial firms, our employee transportation service enhances productivity through smooth and timely travel."
    },
    {
      "name": "Office Cab Service Pune",
      "description": "Office Cab Service Pune provides efficient, affordable, and well-organized travel solutions for daily office commuters. We manage pickup and drop services across multiple routes, ensuring that employees reach their workplaces safely and on time. Our fleet includes sedans, hatchbacks, SUVs, and tempo travellers to match different company requirements. Each vehicle undergoes routine maintenance, cleanliness checks, and safety inspections. Real-time tracking, transparent billing, and 24/7 support make our service dependable for businesses of all sizes. Whether your organization needs daily commute cabs or special-purpose travel arrangements, our office cab services deliver smooth, convenient, and employee-friendly transportation."
    },
    {
      "name": "Corporate Shuttle Service Pune",
      "description": "Corporate Shuttle Service Pune provides premium shared transportation solutions for large teams and corporate parks. Ideal for tech parks, business hubs, and companies located in remote areas, our shuttle service ensures timely and efficient group movement. Each shuttle is spacious, air-conditioned, and equipped with comfortable seating. We offer fixed-route operations, express routes, and customized travel plans based on your company’s shift schedules. Our professional drivers and coordinators ensure seamless travel management, including route planning and peak-hour handling. The service helps reduce traffic congestion, improves employee convenience, and supports environmentally responsible corporate mobility."
    },
    {
      "name": "Staff Pickup and Drop Pune",
      "description": "Staff Pickup and Drop Pune is engineered for organizations that need reliable and round-the-clock transportation for their workforce. Perfect for BPOs, call centers, factories, and IT companies operating multiple shifts. Our fleet supports night shift, early morning, and late-night schedules with maximum safety protocols. Real-time tracking, SOS support, and verified chauffeurs ensure a secure travel experience for staff. Employees experience comfortable seating, air-conditioned cabins, and minimal route delays. By optimizing company travel routes, we reduce costs while improving efficiency and satisfaction. Staff Pickup and Drop Pune is the ideal service for uninterrupted business operations."
    },
    {
      "name": "Business Travel Cabs Pune",
      "description": "Business Travel Cabs Pune offers premium end-to-end cab services for meetings, airport transfers, client visits, and corporate tours. We provide executive sedans, luxury cars, and high-comfort SUVs designed to deliver a professional travel experience. Each chauffeur is well-trained in corporate etiquette, safe driving, and punctual time management. Our cars come equipped with spacious interiors, climate control, and silent cabins for a stress-free ride. Companies can opt for on-demand cabs, scheduled bookings, or full-day rental options. Whether you're transporting VIP clients or employees, our business travel cabs ensure style, comfort, and reliability."
    },
    {
      "name": "Pune Corporate Fleet Service",
      "description": "Pune Corporate Fleet Service delivers comprehensive mobility solutions with a dedicated fleet tailored to your company’s size and operational needs. We offer long-term fleet assignments that include sedans, SUVs, electric cabs, vans, and tempo travellers. Our vehicles are maintained to the highest standards, ensuring smooth performance during daily operations. We provide dedicated chauffeurs, fuel management, monthly reporting, and fully managed fleet operations. Companies benefit from predictable costs, professional coordination, and scalable fleet options. Whether for daily employee travel or large corporate programs, our fleet service ensures uninterrupted, safe, and high-quality transportation."
    },
    {
      "name": "IT Company Cab Service Pune",
      "description": "IT Company Cab Service Pune specializes in structured transportation solutions for tech parks, IT firms, and software companies. We support 24x7 operations with shift-based scheduling, large-scale routing, and automated employee management. Vehicles come with CCTV (optional), GPS tracking, panic buttons, and verified drivers to ensure maximum security, especially for night shifts. Our service helps IT companies reduce absenteeism and improve operational efficiency. With optimized routes, real-time monitoring, and responsive customer support, we offer reliable mobility that integrates smoothly into the IT ecosystem. Perfect for teams working in Hinjewadi, Magarpatta, Kharadi, Baner, and other tech hubs."
    },
    {
      "name": "Corporate Chauffeur Service Pune",
      "description": "Corporate Chauffeur Service Pune offers high-class, professional chauffeur-driven travel for executives, CEOs, managers, and VIP clients. Our chauffeurs are trained in professional etiquette, safe long-distance driving, and confidentiality. Vehicles include luxury sedans, premium SUVs, and corporate-class cars equipped with modern amenities. Ideal for board meetings, airport transfers, corporate visits, and high-profile events. We prioritize comfort, privacy, punctuality, and convenience. With flexible hourly packages and full-day rentals, companies can rely on a seamless and sophisticated travel experience. This service reflects professionalism and enhances your organization’s corporate image."
    },
    {
      "name": "Corporate Sedan Cab Pune",
      "description": "Corporate Sedan Cab Pune provides stylish, comfortable, and executive-grade sedan vehicles for business travelers. Sedans like Dzire, Etios, Honda City, and Hyundai Verna ensure premium comfort for meetings, office commutes, and outstation corporate trips. Ideal for managers, executives, and sales teams who prefer safe, silent, and smooth journeys. Every sedan is well-maintained, sanitized, and equipped with AC, spacious interiors, and smooth suspension. Our professional chauffeurs ensure punctual and safe travel across Pune and nearby cities. Corporate Sedan Cab Pune is the perfect choice for businesses looking for convenience and class."
    },
    {
      "name": "Employee Transport Provider Pune",
      "description": "Employee Transport Provider Pune delivers end-to-end transportation management for companies requiring bulk staff movement. We offer multi-route scheduling, employee mapping, attendance integration, and centralized management dashboards. Vehicles include sedans, vans, mini-buses, and tempo travellers to match different employee capacities. Safety protocols include driver background verification, GPS tracking, and timely maintenance. Our service is ideal for manufacturing units, IT companies, corporate offices, and industrial plants. With efficient routing and dependable service, we help businesses lower logistic costs while improving employee convenience and satisfaction."
    },
    {
      "name": "Best Corporate Cabs Pune",
      "description": "Best Corporate Cabs Pune delivers top-tier, reliable, and professionally managed cab services for daily corporate travel. Companies can choose from a wide fleet of executive sedans, SUVs, luxury cars, and shared transport vehicles. Known for punctuality and superior service quality, we cater to short-distance and long-distance corporate trips. Our cabs come with clean interiors, AC, and trained drivers who understand business travel expectations. We provide flexible monthly billing, route planning, and round-the-clock support. Trusted by top companies across Pune, our corporate cabs ensure a smooth and premium travel experience."
    },
    {
      "name": "Monthly Corporate Cabs Pune",
      "description": "Monthly Corporate Cabs Pune offers a cost-effective and convenient solution for companies looking for long-term cab arrangements. Businesses receive dedicated cabs and chauffeurs assigned exclusively to their organization. The service ensures consistent vehicle availability, predictable billing cycles, and uninterrupted employee mobility. Vehicles are replaced immediately in case of mechanical issues to avoid downtime. Monthly plans reduce per-trip costs and help companies manage their travel budgets more efficiently. Ideal for executives, field teams, and continuous inter-office travel needs within Pune and nearby cities."
    },
    {
      "name": "Corporate SUV Cabs Pune",
      "description": "Corporate SUV Cabs Pune provides high-comfort, spacious, and premium SUVs ideal for business groups, executive travel, and long-distance corporate trips. SUVs like Ertiga, Innova, and Crysta offer superior legroom, luggage capacity, and luxury. These vehicles are perfect for outstation meetings, corporate retreats, airport transfers, and VIP movement. Each SUV is maintained in top condition with AC, plush seating, and advanced safety features. Professional chauffeurs ensure smooth rides and punctual service. Corporate SUV Cabs Pune enhances comfort, prestige, and convenience for business travelers seeking a superior ride experience."
    },
    {
      "name": "Corporate Tempo Traveller Pune",
      "description": "Corporate Tempo Traveller Pune is the best choice for large teams traveling together for corporate events, conferences, outstation trips, and office commute. Tempo Travellers come in multiple seating options such as 12, 17, and 20-seaters, all spacious and air-conditioned. Perfect for bulk employee movement, corporate outings, and business travel. Every vehicle offers push-back seats, ample luggage space, and comfortable interiors. Chauffeurs are trained for long-route driving and ensure safe, timely travel. Companies benefit from reduced costs per employee and organized team movement. This service ensures comfort, safety, and coordination for corporate groups."
    }
  ],
  "tableData": [
    ["Corporate Taxi Service Pune", "Employee Transportation Service Pune"],
    ["Office Cab Service Pune", "Corporate Shuttle Service Pune"],
    ["Staff Pickup and Drop Pune", "Business Travel Cabs Pune"],
    ["Pune Corporate Fleet Service", "IT Company Cab Service Pune"],
    ["Corporate Chauffeur Service Pune", "Corporate Sedan Cab Pune"],
    ["Employee Transport Provider Pune", "Best Corporate Cabs Pune"],
    ["Monthly Corporate Cabs Pune", "Corporate SUV Cabs Pune"],
    ["Corporate Tempo Traveller Pune", ""]
  ],


    "whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and premium corporate cab services in Pune, ensuring smooth and efficient travel for employees and business executives."
  },
  {
    "WhyChooseheading": "Comfortable and Professional Travel",
    "WhyChoosedescription": "Our corporate cabs are equipped with spacious seating and a professional setup to ensure a comfortable and productive commute."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet",
    "WhyChoosedescription": "We maintain our vehicles regularly to deliver clean, safe, and hygienic rides suited for corporate standards."
  },
  {
    "WhyChooseheading": "Transparent and Corporate-Friendly Pricing",
    "WhyChoosedescription": "Enjoy clear and competitive pricing with no hidden charges, ideal for monthly and long-term corporate travel needs."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from a range of travel plans, including daily office commute, outstation business trips, and on-demand corporate cab services."
  },
  {
    "WhyChooseheading": "Experienced & Trained Chauffeurs",
    "WhyChoosedescription": "Our chauffeurs are well-trained, punctual, and experienced in corporate travel, ensuring safe and smooth rides."
  },
  {
    "WhyChooseheading": "24/7 Corporate Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, schedule changes, and travel coordination."
  },
  {
    "WhyChooseheading": "Quick & Hassle-Free Booking",
    "WhyChoosedescription": "Book your corporate cab easily through our fast online system or by phone, with prompt confirmations and reliable service."
  }
]






















  }

  const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services across Pune for daily office travel, meetings, and client visits.',
  },
  {
    question: 'How can I book a corporate cab with Pune Corporate Cars India Private Limited?',
    answer: 'You can easily book through our website, mobile app, or by calling our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Pune?',
    answer: 'We offer a range of vehicles including sedans, SUVs, and premium cars to meet various corporate travel needs.',
  },
  {
    question: 'Are the drivers trained for corporate travel requirements?',
    answer: 'Yes, all our drivers are professional, well-trained, courteous, and experienced in handling corporate travel requirements.',
  },
  {
    question: 'Can Pune Corporate Cars India Private Limited provide cabs for daily office commute?',
    answer: 'Absolutely. We offer flexible daily, weekly, and monthly corporate cab packages for office commute.',
  },
  {
    question: 'Is the corporate cab service available 24×7 in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers round-the-clock availability for corporate cab bookings.',
  },
  {
    question: 'What safety and hygiene measures are maintained in corporate cabs?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment modes are accepted for corporate cab services?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and corporate invoicing options.',
  },
  {
    question: 'Is customer support available during the corporate cab service period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you during your corporate cab service.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Pune Corporate Cars India Private Limited provides excellent corporate cab service. The vehicles are clean, and the drivers are very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shweta Gokhale',
    feedback: 'Reliable and punctual service for our office commute. Highly recommend Pune Corporate Cars India Private Limited for corporate travel solutions.',
    rating: 5,
  },
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-pune.jpg", // replace with actual image URL
  "description": "Premium and reliable corporate cab services in Pune, offering employee transportation, office pickup and drop, corporate shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited provides managed fleets, chauffeur-driven sedans, SUVs, and tempo travellers for companies.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "5100", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Pune | Employee Transport & Office Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Premium corporate cab services in Pune offering employee transportation, office pickup and drop, corporate shuttle services, and business travel cabs. Book reliable and safe corporate fleet services with Pune Corporate Cars India Private Limited."
  />

  <meta
    name="keywords"
    content="Corporate Taxi Service Pune, Employee Transportation Service Pune, Office Cab Service Pune, Corporate Shuttle Service Pune, Staff Pickup and Drop Pune, Business Travel Cabs Pune, Pune Corporate Fleet Service, IT Company Cab Service Pune, Corporate Chauffeur Service Pune, Corporate Sedan Cab Pune, Employee Transport Provider Pune, Best Corporate Cabs Pune, Monthly Corporate Cabs Pune, Corporate SUV Cabs Pune, Corporate Tempo Traveller Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpune;